/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewCourierResolver
 */
export interface NewCourierResolver {
    /**
     * 
     * @type {string}
     * @memberof NewCourierResolver
     */
    realm?: string;
    /**
     * 
     * @type {string}
     * @memberof NewCourierResolver
     */
    adminUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof NewCourierResolver
     */
    customerUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof NewCourierResolver
     */
    marketingUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof NewCourierResolver
     */
    courierId?: number;
}

/**
 * Check if a given object implements the NewCourierResolver interface.
 */
export function instanceOfNewCourierResolver(value: object): value is NewCourierResolver {
    return true;
}

export function NewCourierResolverFromJSON(json: any): NewCourierResolver {
    return NewCourierResolverFromJSONTyped(json, false);
}

export function NewCourierResolverFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewCourierResolver {
    if (json == null) {
        return json;
    }
    return {
        
        'realm': json['realm'] == null ? undefined : json['realm'],
        'adminUrl': json['adminUrl'] == null ? undefined : json['adminUrl'],
        'customerUrl': json['customerUrl'] == null ? undefined : json['customerUrl'],
        'marketingUrl': json['marketingUrl'] == null ? undefined : json['marketingUrl'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function NewCourierResolverToJSON(json: any): NewCourierResolver {
    return NewCourierResolverToJSONTyped(json, false);
}

export function NewCourierResolverToJSONTyped(value?: NewCourierResolver | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'realm': value['realm'],
        'adminUrl': value['adminUrl'],
        'customerUrl': value['customerUrl'],
        'marketingUrl': value['marketingUrl'],
        'courierId': value['courierId'],
    };
}

